import React from 'react';
import './Portfolio.css';
import { motion } from 'framer-motion';
import Videos from './Videos';
import { useNavigate } from 'react-router-dom';

const portfolioItems = [
  {
    title: 'Luxury Bed Design',
    image: './images/bed2.jpg',
    caption:'./images/beds.pdf'
  },
  {
    title: 'Center Tables',
    caption:'./images/center.pdf',
    image: 'https://images.unsplash.com/photo-1643558544531-bff73bbffc28?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2VudGVyJTIwdGFibGV8ZW58MHx8MHx8fDA%3D'
  },
  {
    title: 'Counters',
    caption:'./images/counternew.pdf',
    image: './images/insurancebanner.jpg'
  },
  {
    title: 'Dinning Tables',
    caption:'./images/diningTable.pdf',
    image: './images/dtable.jpg'
  },
  {
     title: 'Sofa Sets',
     caption:'./images/sofaset.pdf',
     image: 'https://media.istockphoto.com/id/1044827658/photo/an-elegant-navy-blue-sofa-in-the-middle-of-a-bright-living-room-interior-with-gold-metal-side.webp?a=1&b=1&s=612x612&w=0&k=20&c=y9BXX0rQthLJaiFo0mePoGy3lEl4JxdArPtMjBLIZGs='
   },
  {
    title: 'General Catalogue',
    caption:'./images/generalcatalog.pdf',
    image: './images/general.jpg'
  },
  {
    title: 'Restaurant Furniture',
    caption:'./images/restuarant.pdf',
    image: 'https://images.unsplash.com/photo-1667388969250-1c7220bf3f37?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cmVzdGF1cmFudCUyMGludGVyaW9yfGVufDB8fDB8fHww'
  },
  {
    title: 'Doors',
    caption:'./images/doors.pdf',
    image: 'https://plus.unsplash.com/premium_photo-1678338049616-cfa9d462f85a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8d29vZGVuJTIwZG9vcnN8ZW58MHx8MHx8fDA%3D'
  },
  {
    title: 'Kitchens',
    caption:'./images/kitchens.pdf',
    image: 'https://images.unsplash.com/photo-1600122272511-c85c3a0209f9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGtpdGNoZW5zfGVufDB8fDB8fHww'
  },
  {
    title: 'Kitchenettes',
    caption:'./images/kitchenettes.pdf',
    image: 'https://images.unsplash.com/photo-1702014861373-527115231f8c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8a2l0Y2hlbmV0dGVzfGVufDB8fDB8fHww'
  },
  {
    title: 'Office Furniture',
    caption:'./images/officefurniture.pdf',
    image: 'https://images.unsplash.com/photo-1571624436279-b272aff752b5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8b2ZmaWNlJTIwZnVybml0dXJlfGVufDB8fDB8fHww'
  },
  {
    title: 'TV Units',
    caption:'./images/tvunit.pdf',
    image: 'https://images.unsplash.com/photo-1743435009576-1beabc1043bd?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8dHYlMjB1bml0fGVufDB8fDB8fHww'
  }
];

const Portfolio = () => {
   const nav = useNavigate()
  return (
    <section className="portfolio">
      <motion.h2 
        className="portfolio-title"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        onClick={()=>nav('/catalog')}
      >
        Our  Catalogue
      </motion.h2>

      <div className="portfolio-grid">
        {portfolioItems.map((item, index) => (
          <motion.div
            key={index}
            className="portfolio-card glass"
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img src={item.image} alt={item.title} className="portfolio-image" />
            <div className="portfolio-info">
              <h3>{item.title}</h3>
              <a href={item.caption} target="_blank"> <button className='view-button3'>View More</button></a>    
            </div>
          </motion.div>
        ))}
      </div>
      {/* <Videos/> */}
    </section>
  );
};

export default Portfolio;
